const config = {
    ...CONFIG,
    "APIs": {
        "getUserDetails": "user/details",
        "getLanguages": "language/list",
        "setLanguage": "language/setLanguage"
    },
}

__webpack_public_path__ = config.mainAppUrl;
export default config;